import React from 'react';
import { formatPurposeForDisplay, getRequestedDateRange } from './sharedAccessFormatters';

/** Purpose: Renders request/share details tile. Inputs: { permissionInfo, formatDate, formatRecordType }. Output: React render output (JSX). */
export default function SharedRequestDetails({ permissionInfo, formatDate, formatRecordType }) {
  return (
    <section className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
      <h2 className="text-lg font-semibold text-slate-900 mb-4">Request Details</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
        <div>
          <p className="text-slate-500">Shared With</p>
          <p className="font-medium text-slate-900">{permissionInfo?.grantedTo}</p>
        </div>
        <div>
          <p className="text-slate-500">Organization</p>
          <p className="font-medium text-slate-900">{permissionInfo?.organization}</p>
        </div>
        <div>
          <p className="text-slate-500">Purpose</p>
          <p className="font-medium text-slate-900">
            {formatPurposeForDisplay(permissionInfo?.purpose, formatRecordType)}
          </p>
        </div>
        <div>
          <p className="text-slate-500">Date Range Requested</p>
          <p className="font-medium text-slate-900">{getRequestedDateRange(permissionInfo, formatDate)}</p>
        </div>
        <div>
          <p className="text-slate-500">Access Expires</p>
          <p className="font-medium text-slate-900">{formatDate(permissionInfo?.expiresAt)}</p>
        </div>
      </div>
    </section>
  );
}

